/* eslint-disable */
import { Config, Pagination } from 'is-search';

export default () => {

    /**
     * All available query parameters
     */
    const options = new Config();
    options.endpoint           = process.env.SEARCH_ENDPOINT;
    options.searchURL          = process.env.SEARCH_URL;
    options.defaultQueryParams = { _limit: 5, _page: 1, q: '' };
    options.pagerParam         = '_page';

    /**
     * Instantiate the primary Search and Pagination classes
     */
    const search      = new Pagination(options);

    search.init();

    /**
     * Search templates being used to output HTML. Optional not Required
     */
    search.templates = {
      count:    '<div>Showing <strong>%start-%end</strong> of <strong>%totalResults</strong></div>',
      keywords: 'results for <strong class="search-results-text-keywords">%keywords</strong>'
    };

    /**
     * Event callback for AJAX requests which build the results and pager
     */
    $(search)
      .on('isLoading', _isLoading)
      .on('HandleResponse', _HandleResponse)
      .on('HandleResponse', _buildPagination)
    ;

    /**
     * Disable/enable submit button if no keywords are present
     */
    if (!$('.search-results-hero-input').val() || !search.keywords) {
      $('.search-results-hero-input').next().attr('disabled', true);
    }

    $('.search-results-hero-input').on('input propertychange', (e) => {
      if ($(e.currentTarget).val()) {
        $(e.currentTarget).next().attr('disabled', false);
      } else {
        $(e.currentTarget).next().attr('disabled', true);
      }
    });

    /**
     * Keyword search
     */
    $('html')
      // on click
      .on('click', '.search-results-hero-submit, .js-site-header-search-submit, .mobile-nav-search-submit', _keywordSearch)
      // on enter key
      .on('keydown', '.search-results-hero-input, .js-site-header-search-input, .mobile-nav-search-input', (event) => {
        if (event.keyCode === 13) {
          _keywordSearch(event);
        }
      })
    ;

    /**
     * Pagination arrows and numbers click events
     */
    $('html')
      .on('click', '.search-results-wrapper .pagination-prev, .search-results-wrapper .pagination-next', (e) => {
        e.preventDefault();
        $(e.currentTarget).trigger('blur');
      })
      .on('click', '.search-results-wrapper .pagination-prev', search.previousPage.bind(search))
      .on('click', '.search-results-wrapper .pagination-next', search.nextPage.bind(search))
      .on('click', '.search-results-wrapper .pagination-pages a', _paginationTrigger)
    ;

    /**
     * Callback for build the pagination based off the returned results.
     *
     * @private
     * @method _buildPagination
     * @return undefined
     */
    function _buildPagination() {
      $('.search-results-wrapper .pagination-pages').empty();
      if (search.keywords) {
        search.buildPager().map(_buildPaginationItem);
      }
    }

    /**
     * Callback for building an individual pager item.
     *
     * @private
     * @method _buildPaginationItem
     * @param { Object } page
     * @return undefined
     */
    function _buildPaginationItem(page) {
      const { current, link, text, value } = page,
            currentHTML = `<a href="#" data-page="${value}" data-current="true"><span class="sr-text">Page </span>${text}</li>`;

      let defaultHTML = `<a href="${link}" data-page="${value}"><span class="sr-text">Page </span>${text}</a>`;

      if (current === true) {
        $('.search-results-wrapper .pagination-mobile-current').text(page.value);
        $('.search-results-wrapper .pagination-mobile-total').text(search.totalPages);
      }

      if (link === null) {
        defaultHTML = `<span class="pagination-pages-dots">${text}</span>`;
      }

      $('.search-results-wrapper .pagination-pages').append(current ? currentHTML : defaultHTML);

    }

    /**
     * Callback for processing the keywords entered into the search.
     *
     * @private
     * @method _keywordSearch
     * @param { Object } event
     * @return undefined
     */
    function _keywordSearch(event) {
      event.preventDefault();

      const parent   = $(event.target).parent(),
            keywords = parent.find('input').val();

      // Close the header search if open.
      if ($('.js-site-header-search').hasClass('-open')) {
        $('.js-site-header-search').removeClass('-open').fadeToggle(150);
      }

      // Close the mobile menu if open.
      if ($('html').attr('data-nav-open') === 'true') {
        $('html').attr('data-nav-open', 'false');
      }

      // Redirect the user to the search page if they are using the header search.
      if (window.location.pathname !== options.searchURL) {
        search.query['q'] = keywords;
        return window.location = search._buildURL();
      }

      search._helperUpdateKeywords(keywords);
    }

    /**
     * Callback being used to as the click event for the pagintation.
     *
     * @private
     * @method _paginationTrigger
     * @param { Object } event
     * @return undefined
     */
    function _paginationTrigger(event) {
      event.preventDefault();

      const page = $(event.target).data('page');
      search._helperUpdatePage(page);
    }


    /**
     * Callback that allows for a progress loaded to be initialized and de-initialized.
     *
     * @private
     * @method _isLoading
     * @param { Object } event
     * @param { Boolean } state true|false
     * @return undefined
     */
    function _isLoading(event, state) {
      switch (state) {
        case true:
          $('.search-results-loading').show();
          $('search-results-items').hide();
          break;
        default:
          $('.search-results-loading').hide();
          $('search-results-items').show();
          break;
      }
    }


    /**
     * Callback for the primary AJAX responses.
     *
     * @private
     * @method _HandleResponse
     * @param { Object } event
     * @param { JSON } response
     * @return undefined
     */
    function _HandleResponse(event, response) {
      const { results } = response,
            { firstResult, keywords, lastResult, totalResults, totalPages } = search;

      // Disable/enable pagination arrows if first or last page is the current page
      setTimeout(() => {

        if (parseInt($('.search-results-wrapper .pagination-pages a[data-current="true"]').data('page')) === totalPages) {
          $('.search-results-wrapper .pagination-next').attr('disabled', true);
        } else {
          $('.search-results-wrapper .pagination-next').attr('disabled', false);
        }

        if (parseInt($('.search-results-wrapper .pagination-pages a[data-current="true"]').data('page')) === 1) {
          $('.search-results-wrapper .pagination-prev').attr('disabled', true);
        } else {
          $('.search-results-wrapper .pagination-prev').attr('disabled', false);
        }

      }, 100);

      // Empty out the current search results.
      $('.search-results-text, .search-results-items').empty();

      // Make sure the search form matches the parameter in the URL if set.
      // Mostly done for when a user enters a page directly from a query link.
      if (keywords !== '' && $('.search-results-hero-input').val() !== keywords) {
        $('.search-results-hero-input').val(keywords);
      }

      // Make sure keywords are given
      if (!keywords) {
        $('.search-results-no-keywords').show();
        $('.search-results-no-results').hide();
        $('.search-results-wrapper .pagination').hide();
        return false;
      }

      // Handle no results
      if (totalResults === 0) {
        $('.search-results-no-results').show();
        $('.search-results-no-results-keywords').text(keywords);
        $('.search-results-no-keywords').hide();
        $('.search-results-wrapper .pagination').hide();
        return false;
      }

      // Hide pagination if only a single page
      if (totalResults <= options.defaultQueryParams._limit) {
        $('.search-results-wrapper .pagination').hide();
      }

      // Hide no results and no keywords if results
      // Show pagination arrows if results
      if (keywords && totalResults > 0) {
        $('.search-results-no-results').hide();
        $('.search-results-no-keywords').hide();
        $('.search-results-wrapper .pagination').show();
      }

      // Build the Showing and Results template for the top.
      let count = search.template('count', [
        { variable: '%start',        value: firstResult  },
        { variable: '%end',          value: lastResult   },
        { variable: '%totalResults', value: totalResults }
      ]);

      // Attach keywords results for "amet" if keywords are available.
      if (keywords) {
        const words = search.template('keywords', [
          { variable: '%keywords', value: keywords }
        ]);

        count = count.replace('</div>', ' ' + words);
      }

      // Insert the count template into the .search-results-text placeholder.
      $('.search-results-text').append(count);

      // Build and output each individual search result.
      results.map(({ url, title, excerpt, image }) => {
        const excerptTrunc = excerpt.trunc(168);
        const template = `
          <a class="teaser" href="${url}">
            <div class="teaser-inner">
              <div class="teaser-content">
                <h5 class="teaser-title">${title}</h5>
                <div class="teaser-excerpt">${excerptTrunc} <span class="teaser-excerpt-readmore">Read more</span></div>
              </div>
              ${image ? '<div class="teaser-image">' : ''}
                ${image ? '<div class="teaser-image-inner" style="background-image: url(\'' + image + '\')"></div>' : ''}
              ${image ? '</div>' : ''}
            </div>
          </a>
        `;


        $('.search-results-items').append(template);
      });

      // Smooth scroll to top of the page for new search or pagination clicks
      $('html, body').animate({
        scrollTop: $('.search-results-hero').offset().top
      }, 400);
    }
};
